const emailCreateFormatter = (data, defaultFormData) => {
  const dataSet = data?.data || data;
  const formData = JSON.parse(JSON.stringify(defaultFormData));
  formData["id"] = dataSet["id"];
  return formData;
};

export default emailCreateFormatter;
